import apiClient from './client'
import type { Aviso, PaginatedResponse } from '@/types/aviso'

export const misAvisosApi = {
    getAll: (params?: { page?: number; pageSize?: number; search?: string; finalizado?: number; todos?: 1 }) =>
        apiClient.get<PaginatedResponse<Aviso>>('/avisos/mis', { params }).then((r) => r.data),

    getById: (id: number) =>
        apiClient.get<Aviso>(`/avisos/mis/${id}`).then((r) => r.data),
}
